import getConfig from 'next/config'
import { setClientEnv } from '@mc/client-env'

export function init() {
  setClientEnv(getConfig().publicRuntimeConfig)
}
